<template>
  <v-dialog :value="true" persistent no-click-animation max-width="620">
    <v-card>
      <v-card-title class="headline">Admin Panel is being retired</v-card-title>
      <v-card-text>
        <p>
          Everything you do for <strong>{{ site.name }}</strong> now lives in Centric.
        </p>
        <template v-if="canRequest">
          <p>
            If something is missing from Centric let us know.
          </p>
          <v-form ref="form">
            <v-textarea outline auto-grow rows="3" label="(optional)" v-model="reason" />
          </v-form>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-btn flat :href="centricSiteURL" target="_blank">Open in Centric</v-btn>
        <v-spacer />
        <v-btn v-if="canRequest" color="primary" :loading="submitting" @click="submit">
          Continue to Admin Panel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { centricOSURL } from '@/helpers';

export default {
  props: {
    site: {
      type: Object,
      required: true,
    },
    access: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    reason: '',
    submitting: false,
  }),
  mounted() {
    // requests only tell us about the people who ask; impressions are the
    // denominator, and the route says which page they were trying to open
    if (window.heap) {
      window.heap.track('ap3_access_blocked', {
        site: this.site.id,
        site_name: this.site.name,
        access: this.access,
        route: this.$route.name,
        can_request: this.canRequest,
      });
    }
  },
  computed: {
    ...mapGetters('adminPanel', ['isAdmin']),
    // gated lets a site talk its way back in, but only an admin may do it
    canRequest() {
      return this.access === 'gated' && this.isAdmin;
    },
    centricSiteURL() {
      return `${centricOSURL()}/sites/${this.site.id}/menu-hours`;
    },
  },
  methods: {
    ...mapActions('sites', ['grantAp3Access']),
    async submit() {
      if (!this.$refs.form.validate()) return;
      this.submitting = true;
      try {
        await this.grantAp3Access({ siteId: this.site.id, reason: this.reason });
        this.$toast.success('Admin Panel access restored for this site');
      } catch (err) {
        console.error('ap3 access request failed', err);
        this.$toast.error('Could not restore access, please try again');
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
